import ApproverSignoffPage from './ApproverSignoffPage'

export default function BuHeadSignoff () {
  return <ApproverSignoffPage level={3} />
}
